import { map } from "rxjs/operators";
import { ContactsType } from "../../../components/Modals/ContactsModal/module/constants";
import { OtpOperationType } from "../../../module/constants";

import { GET, POST } from "../../../module/services/fetch";
import { IDataPostLogin } from "./constants";
import { getTargetIdBasedOnEnv } from "../../../utils/utils";

export const fetchLogin = (values: any) => {
  const headers = new Headers({
    "Content-type": "application/x-www-form-urlencoded",
    Accept: "*/*",
    "Accept-Encoding": "gzip, deflate, br",
  });
  let params = {
    grant_type: "password",
    username: values.user,
    password: values.pwd,
    client_id: "10b56c3e-5e00-4bbc-b2c7-d9e0251c749a",
  };
  let formBody = [];
  for (var property in params) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(
      params[property as keyof typeof params]
    );
    formBody.push(encodedKey + "=" + encodedValue);
  }
  let resBody = formBody.join("&");

  return POST("oauth/v2/token", resBody, headers).pipe(
    map((response: any) => response)
  );
};

export const sendInternetOtpLogin = (otp: string) => {
  const headers = new Headers({
    "Content-type": "application/x-www-form-urlencoded",
    Accept: "*/*",
    "Accept-Encoding": "gzip, deflate, br",
  });
  let params = {
    grant_type: "password",
    client_id: "10b56c3e-5e00-4bbc-b2c7-d9e0251c749a",
    otp: otp,
  };

  let formBody = [];

  for (var param in params) {
    var encodedKey = encodeURIComponent(param);
    var encodedValue = encodeURIComponent(params[param as keyof typeof params]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  let resBody = formBody.join("&");

  return POST("oauth/v2/otp", resBody, headers).pipe(
    map((response: any) => response)
  );
};

export const fetchDomains = () => {
  return GET("authentication/domains").pipe(map((res: any) => res));
};

export const postLoginAnswer = (payload: IDataPostLogin) => {
  return POST("oauth/v2/reset-token", payload, {
    "Content-Type": "application/x-www-form-urlencoded",
  }).pipe(map((res: any) => res));
};

export const postLoginOtp = (body: IDataPostLogin) => {
  return POST("oauth/v2/reset-token", body, {
    "Content-Type": "application/x-www-form-urlencoded",
  }).pipe(map((res: any) => res));
};

export const fetchPasswordPolicy = () => {
  const body = {
    targetId: getTargetIdBasedOnEnv(),
    identitySystemId: "1",
  };
  return POST("user/account/passwordPolicyByTargetId", body).pipe(
    map((response: any) => response)
  );
};

export const postPassword = (token: string, data: string) => {
  let header = new Headers();
  header.set("Content-Type", "application/x-www-form-urlencoded");
  header.set("Authorization", token);
  header.set("Allow-Origin", "*/*");
  return POST("authentication/reset/password", data, header).pipe(
    (res: any) => res
  );
};

export const changeFirstPasswordService = (payload: {
  token: string;
  newPwd: string;
  oldPwd: string;
}) => {
  const { newPwd, oldPwd, token } = payload;
  let header = new Headers();
  header.set("Authorization", token);
  return POST(
    `changeFirstPass`,
    { currentPassword: oldPwd, newPassword: newPwd, domain: "xcorp" },
    header
  ).pipe((res: any) => res);
};

export const generateOTP = (body: {
  operation: OtpOperationType;
  method: ContactsType;
  userCode?: string;
}) => {
  const { method, operation, userCode } = body;
  return GET(
    `authentication/otp?${userCode ? `userCode=${userCode}` : ""}${
      !userCode ? `operation=${operation}` : `&operation=${operation}`
    }&deliveryMethod=${method}`
  ).pipe(map((res: any) => res));
};

export const verifyUigpOTP = (body: {
  operation: OtpOperationType;
  userCode: string;
  otp: string;
}) => {
  const { operation, otp, userCode } = body;
  return POST(
    `authentication/verify-otp?userCode=${userCode}&operation=${operation}`,
    otp
  ).pipe(map((res: any) => res));
};
